import React from "react";
import styled from "styled-components";
import { Loading } from "../Loading";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0.2rem 0;
  .text-btn {
    cursor: pointer;
    width: calc(100%);
    padding: var(--fs-textfield) 1rem;
    border-radius: calc(var(--border-radius) / 2);
    border: none;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background-color: var(--n-primary-4);
    color: var(--body-1);
    font-weight: 500;
    &.link {
      text-decoration: none;
      width: calc(100% - 2rem);
    }
    &.btn-type-1 {
      background-color: var(--n-primary-1-o);
      color: var(--n-primary-1);
      border: 1px solid var(--n-primary-1);
      :hover {
        background-color: var(--n-primary-1-o2);
      }
    }
    &.btn-type-2 {
      background-color: var(--n-primary-1-o);
      color: var(--n-primary-1);
      border: 1px solid var(--n-primary-1);
      padding: 8px 1rem;
      width: fit-content;
      :hover {
        background-color: var(--n-primary-1-o2);
      }
    }
    :hover {
      background-color: var(--n-primary-5);
    }
    :disabled {
      background-color: var(--border-1);
      color: var(--border-3);
    }
  }
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      text-align: center;
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0 0.2rem 0 0;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: 0.7rem 1rem;
    }
  }
`;

export const TextBtn = ({
  style,
  className,
  type,
  name,
  text,
  onclick,
  disabled,
  loading,
  newType1,
  link,
}) => {
  let classes = "text-btn";
  if(newType1) {
    classes+= " btn-type-1"
  }
  if(newType1 === 2) {
    classes+= " btn-type-2"
  }
  if (loading) {
    return (
      <Styles style={style}>
        <button
          type={type}
          className={classes + ' ' +className}
          name={name}
          onClick={onclick}
          disabled={disabled}
        >
          <Loading />
        </button>
      </Styles>
    );
  }
  if(link){
    return (
      <Styles style={style}>
        <a
          type={type}
          className={classes + ' link'}
          name={name}
          disabled={disabled}
          href={link}
        >
          {text}
        </a>
      </Styles>
    );
  }
  return (
    <Styles style={style}>
      <button
        type={type}
        className={classes}
        name={name}
        onClick={onclick}
        disabled={disabled}
      >
        {text}
      </button>
    </Styles>
  );
};
